import React from 'react';
import { Link } from 'react-router-dom';
import { string, func } from 'prop-types';

import classes from './ActionsPanelItem.module.css';

/**
 * Conditionally renders a link/button tag or a non-interactive `div` depending
 * on whether or not a `href` or `onClick` prop is provided (and thus is
 * interactive). This allows items that are interactive to be accessible
 * (rendering an anchor or button tag) and non-interactive (i.e. TODO) items to
 * render as simple `div`s.
 */
const ActionsPanelItem = ({ href, iconUrl, onClick, title, hidden }) => {
    let Root = 'div';
    const props = {
        className: classes.root
    };
    if (href) {
        props.to = href;
        Root = Link;
    } else if (onClick) {
        props.onClick = onClick;
        Root = 'button';
    }

    if (hidden) return null;

    return (
        <Root {...props}>
            {iconUrl && <img src={iconUrl} alt={title} />}
            <span>{title}</span>
        </Root>
    );
};

ActionsPanelItem.propTypes = {
    href:    string,
    iconUrl: string.isRequired,
    onClick: func,
    title:   string.isRequired
};


export default ActionsPanelItem;
